import { apiClient } from '@/utils/api'

export interface BracketPlayer {
  userId: string
  displayName: string
  avatar?: string
  ranking: number
  // Standings data
  wins: number
  losses: number
  points: number
  gamesPlayed: number
  joinedAt: string
}

interface BracketPlayersResponse {
  data: BracketPlayer[]
  meta: { total: number }
}

export const bracketPlayerService = {
  async list(bracketId: string): Promise<BracketPlayer[]> {
    const response = await apiClient.authGet<BracketPlayersResponse>(
      `/brackets/${bracketId}/players`
    )
    return response.data
  },

  async add(bracketId: string, userId: string): Promise<BracketPlayer> {
    const response = await apiClient.authPost<{ data: BracketPlayer }>(
      `/brackets/${bracketId}/players`,
      { userId }
    )
    return response.data
  },

  async remove(bracketId: string, userId: string): Promise<void> {
    await apiClient.authDelete(`/brackets/${bracketId}/players/${userId}`)
  },

  async listPublic(bracketId: string): Promise<BracketPlayer[]> {
    const response = await apiClient.get<BracketPlayersResponse>(
      `/brackets/${bracketId}/players/public`
    )
    return response.data
  },
}
